function getPluginHandlers(plugins, key) {
  return plugins.reduce((handlers, plugin) => {
    const handler = plugin[key];
    return handler ? [...handlers, handler] : handlers;
  }, []);
}

export { getPluginHandlers };
